import React, { Component } from 'react'
import { View, ScrollView } from 'react-native'
import { translate } from 'react-i18next';
import { UserDataConsumer } from '../../utils';
import { GoalCardWithNutritionDescription, CouponCopyWithButton, MealDeliveryDescriptionWithImage, AppStateFocusedEvents } from '../../ui/components'
import { nutritionTabSelected } from '../actions';
import { connect } from 'react-redux';
import Theme from '../../theme';

class OrderMeals extends Component {
    componentDidMount() {
        this.props.nutritionTabSelected('Order Meals');
    }

    onFocus = () => {
        this.props.nutritionTabSelected('Order Meals');
    }

    render() {
        const longTermGoal = this.props.user.userProfile.longTermGoal;
        return (
            <>
                <AppStateFocusedEvents
                    navigation={this.props.navigation}
                    onScreenFocus={this.onFocus} />
                <ScrollView style={{ backgroundColor: Theme.WHITE, flex: 1 }}>
                    <MealDeliveryDescriptionWithImage />
                    <GoalCardWithNutritionDescription longTermGoal={longTermGoal} />
                    <CouponCopyWithButton longTermGoal={longTermGoal} />
                    <View />
                </ScrollView>
            </>
        )
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        nutritionTabSelected: (tabTitle) => dispatch(nutritionTabSelected(tabTitle)),
    }
}

OrderMeals = UserDataConsumer(connect(null, mapDispatchToProps)(OrderMeals));
export default translate(['nutrition'], { wait: true })(OrderMeals);
